import { z } from "zod";
export const UserSchema = z.object({
    seed: z.number()
});
export const UserPropertiesDefinition = {
    seed: {
        description: "A random number between 0 and 99 (inclusive) seeded by the appUserId. Useful for routing in campaigns.",
        exampleValues: [
            0,
            35,
            99
        ],
        availableSinceVersion: "3.2.0"
    }
};
export const FrequentlyUpdatingUserProperties = Object.entries(UserPropertiesDefinition).filter(([key, value])=>value.updatesFrequently).map(([key, value])=>key);
